
import initWasm from " vite/wasm-helper.js"
export default opts => initWasm(opts, "__VITE_ASSET__DAZE4t1f__$_?init__")
